import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useStyle } from "./style";
import { envVariable, Variable } from "@/common/constants/envVariable";
import { SentryConfiguration } from "@/common/helpers/sentryHelper";
import * as microsoftTeams from "@microsoft/teams-js";
import { mergeClasses } from "@fluentui/react-components";

export const FallbackComponent = ({ eventId }: any) => {
	const [requestFeedbackEnabled, setRequestFeedbackEnabled] = useState(false);
	const [theme, setTheme] = useState('default');

	const classes = useStyle();

	useEffect(() => {

		getTeamsTheme();
		const sentryConfiguration = envVariable(
			Variable.Sentry
		) as SentryConfiguration;

		const requestFeedbackOnError =
			sentryConfiguration?.requestFeedbackOnError === "true";
		setRequestFeedbackEnabled(requestFeedbackOnError);
		if (!requestFeedbackOnError) {
			return;
		}

		Sentry.showReportDialog({ eventId });
	}, []);

	const getTeamsTheme = () => {
		microsoftTeams.app.getContext().then(ctx => {
			setTheme(ctx.app.theme || "default");
		})
	}

	return (
		<div className={theme === "dark" ? mergeClasses(classes.container, classes.containerDark) : classes.container}>
			<h2 className={theme === "dark" ? mergeClasses(classes.errorText, classes.errorTextDark) : classes.errorText}>
			{requestFeedbackEnabled ? (	
					<>Something went wrong. <br /> Please provide the details in the form and refresh the application afterward</>
			) : (
					<>Something went wrong. <br /> Refresh the application</>
			)}
			</h2>
		</div>
	);
};
